import Details from './Details';
import SignupError from './SignupError';

export { Details };
export default SignupError;
